import { useSyncExternalStore } from "react";
import { onLockStateChange, type LockState } from "../../lockBus";

// #contentWrap ("lockOverlay" in dom.ts) is genuinely shared DOM, so its
// class is a safe way to seed the initial snapshot without importing
// session.ts (which pulls in dom.ts's whole side-effecting graph - same
// standing rule as domBridge.ts). Subsequent changes arrive via
// notifyLockStateChange() through lockBus.ts (windowBus-backed, so it
// crosses the app.js/react-app.js bundle boundary correctly).
function getSnapshot(): LockState {
  return document.getElementById("contentWrap")?.classList.contains("fade-lock") ? "locked" : "unlocked";
}

function subscribe(onStoreChange: () => void): () => void {
  return onLockStateChange(() => onStoreChange());
}

export function useLockState(): LockState {
  return useSyncExternalStore(subscribe, getSnapshot);
}
